export const getVariant = ({ primary, secondary, critical, ghost, }) => {
    if (primary)
        return 'primary';
    if (secondary)
        return 'secondary';
    if (critical)
        return 'critical';
    if (ghost)
        return 'ghost';
    return 'primary';
};
